var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"marginBottom18",class:_vm.isTitle ? 'title' : ''},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('image-component',{attrs:{"path":"","is_jpg":_vm.is_jpg ? '' : false,"name":_vm.ImgTitle}}),_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }